import { BeatResolution, MIDDLE_C, TICKS_PER_LOOP } from '@arpeggi/shared'
import { cast, Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'
import { InstrumentPart } from '../../../client/genesis/genesis_proto_pb'
import { Arp2Utils } from '../../../client/SongUtils'
import { SongGenerator } from '../../../generator/SongGenerator'
import { NoteCollectionStore } from '../../../stores/song/loop/NoteCollectionStore'
import { LoopSettingsStore } from './LoopSettingsStore'

const _DrumSubLoopStore = types
  .model({
    settings: types.optional(LoopSettingsStore, {}),
    notes: types.optional(NoteCollectionStore, {})
  })
  .views((self) => ({
    get lengthOfLoop() {
      return Arp2Utils.getLengthOfRes(self.settings.resolution)
    }
  }))
  .actions((self) => {
    function initialize(resolution: BeatResolution) {
      self.settings = LoopSettingsStore.create({ resolution: resolution })
      self.notes = NoteCollectionStore.create()
    }

    function updateResolution(resolution: BeatResolution) {
      self.settings.resolution = resolution
      // remove any notes that don't fit the resolution
      self.notes.notes = cast(
        self.notes.notes
          .filter((note) => note.start % (TICKS_PER_LOOP / self.lengthOfLoop) === 0)
          .slice()
      )
    }

    function randomizeForSampleCategory(songGenerator: SongGenerator, category: string) {
      songGenerator
        .getDrumGenerator()
        .generateDrumSubloopForCategory(self as IDrumSubLoopStore, category)
    }

    function fromGenesis(part: InstrumentPart, resolution: BeatResolution) {
      self.settings = LoopSettingsStore.create({ resolution: resolution })
      // If this part is disabled, just keep all false
      if (part !== null) {
        part.getNotesList().forEach((note, index, arr) => {
          if (note <= 0) return

          const beatLengthTicks = TICKS_PER_LOOP / arr.length
          self.notes.addNote({
            start: beatLengthTicks * index,
            duration: beatLengthTicks,
            note: MIDDLE_C
          })
        })
      }
    }

    return {
      initialize,
      randomizeForSampleCategory,
      updateResolution,
      fromGenesis
    }
  })

interface DrumSubLoopStoreType extends ForDirectExtend<typeof _DrumSubLoopStore> {}
export const DrumSubLoopStore: DrumSubLoopStoreType = _DrumSubLoopStore

export interface IDrumSubLoopStore extends ForDirectExtend<Instance<typeof DrumSubLoopStore>> {}
